// extracted by mini-css-extract-plugin
export var headLine = "index-module--headLine--TFEPj";